import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

// Components
import TopBar from "./components/TopBar";
import Header from "./components/Header";
import Footer from "./components/Footer";
import { WhatsAppFloat, QuickActionFloat } from "./components/Shared";
import ScrollToTop from "./components/ScrollToTop";

// Pages
import HomePage from "./pages/HomePage";
import AboutPage from "./pages/AboutPage";
import MissionVisionPage from "./pages/MissionVisionPage";
import AimObjectivePage from "./pages/AimObjectivePage";
import AdmissionsPage from "./pages/AdmissionsPage";
import AcademicsPage from "./pages/AcademicsPage";
import LifeAtIdpsPage from "./pages/LifeAtIdpsPage";
import CampusPage from "./pages/CampusPage";
import GalleryPage from "./pages/GalleryPage";
import ContactPage from "./pages/ContactPage";

// Styles
import "./styles/global.css";

function App() {
  return (
    <Router>
      <ScrollToTop />
      <div className="app">
        <TopBar />
        <Header />
        <main className="main">
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/mission-vision" element={<MissionVisionPage />} />
            <Route path="/aim-objective" element={<AimObjectivePage />} />
            <Route path="/admissions" element={<AdmissionsPage />} />
            <Route path="/academics" element={<AcademicsPage />} />
            <Route path="/life-at-idps" element={<LifeAtIdpsPage />} />
            <Route path="/campus" element={<CampusPage />} />
            <Route path="/gallery" element={<GalleryPage />} />
            <Route path="/contact" element={<ContactPage />} />
          </Routes>
        </main>
        <Footer />
        <QuickActionFloat />
        <WhatsAppFloat />
      </div>
    </Router>
  );
}

export default App;
